import React, { useState } from 'react';

interface ImageWithSkeletonProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

// Mostra um placeholder com shimmer até a imagem carregar, depois faz
// crossfade pra imagem real — evita a tela "pular" quando o print entra.
export const ImageWithSkeleton: React.FC<ImageWithSkeletonProps> = ({ src, alt, className = '', ...props }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative min-h-[160px]">
      {!loaded && (
        <div className={`absolute inset-0 rounded-xl skeleton-shimmer animate-shimmer ${className}`} />
      )}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={`transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`}
        {...props}
      />
    </div>
  );
};
